import { Component, Input } from '@angular/core';
import { BaseModalService, CustomerOfferResponse, InquiryResponse, CustomerOfferType } from 'base';
import { Router } from '@angular/router';

@Component({
  selector: 'base-customer-offer-information-tab',
  templateUrl: './base-customer-offer-information-tab.component.html',
})
export class BaseCustomerOfferInformationTabComponent {
  @Input() offer: CustomerOfferType | undefined;
  @Input() inquiry: InquiryResponse | undefined;
  @Input({ required: true }) locationId: number | undefined;

  constructor(private router: Router, private modalService: BaseModalService) {}

  isCustomerOfferResponse(offer: CustomerOfferType): offer is CustomerOfferResponse {
    return 'department' in offer || 'location' in offer;
  }

  openIzsInfoModal(event: Event): void {
    if (!this.locationId) {
      return;
    }

    if (!this.offer) {
      return;
    }

    event.stopPropagation();
    this.modalService.closeAllModals();
    this.router.navigate(['/service-provider'], {
      queryParams: {
        page: 1,
        search: this.offer.pspBranch.name,
        pspBranchId: this.offer.pspBranch.id,
        location: this.locationId,
      },
    });
  }
}
